import { render, staticRenderFns } from "./messageInfo.vue?vue&type=template&id=46f8a570&scoped=true"
import script from "./messageInfo.vue?vue&type=script&lang=js"
export * from "./messageInfo.vue?vue&type=script&lang=js"
import style0 from "./messageInfo.vue?vue&type=style&index=0&id=46f8a570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f8a570",
  null
  
)

export default component.exports